module.exports = "/resources/assets/prod/fe0ce9b9dcebf69416e976bc0b5a5e3c.jpg";